<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <indexHeader
          :title="$t('partnersSettlements.PartnerSettlements')"
          :description="$t('partnersSettlements.FromHereYouCanControlPartnerSettlements')"
        />

        <indexTable
          :searchText="$t('partnersSettlements.SearchForAProcess')"
          :emptyTableText="$t('partnersSettlements.ThereAreCurrentlyNoSettlements')"
          :buttonRole="$checkRole('partners_settlements_add')"
          :emptyTableSubText="$t('partnersSettlements.TryAddingSomeAndTryAgain')"
          :statusSearch="true"
          :statusValues="[
            { title: $t('orders.situation'), value: '' },
            { title: $t('orders.all'), value: '' },
            { title: $t('invoices.draft'), value: 0 },
            { title: $t('invoices.approved'), value: 1 }
          ]"
          :cloumns="[
            {
              column: 'code',
              title: $t('partnersSettlements.operation'),
              type: 'mainLink',
              sort: true
            },
            {
              column: 'safe_id',
              title: $t('partnersSettlements.Project'),
              type: 'link',
              to: 'project',
              sort: true,
              link: true
            },
            {
              column: 'date',
              title: $t('partnersSettlements.date'),
              type: 'text',
              sort: true
            },
            {
              column: 'total',
              title: $t('partnersSettlements.cost'),
              type: 'text',
              sort: true
            },
            {
              column: 'description',
              title: $t('partnersSettlements.thatAbout'),
              type: 'text',
              sort: true
            },
            {
              column: 'user_name',
              title: 'اسم المسئول',
              type: 'text',
              sort: true,
              icon: 'usd-square'
            },
            {
              column: 'status',
              title: $t('bills.situation'),
              type: 'status',
              sort: true,
              values: [
                { title: $t('invoices.draft'), value: 0, color: 'dark' },
                { title: $t('invoices.approved'), value: 1, color: 'success' }
              ]
            },
            {
              column: 'options',
              title: $t('partnersSettlements.settings'),
              type: 'options',
              options: [
                { name: 'show' },
                {
                  name: 'edit',
                  role: $checkRole('partners_settlements_edit')
                },
                { name: 'file' },
                {
                  name: 'delete',
                  role: $checkRole('partners_settlements_delete')
                }
              ]
            }
          ]"
          :deleteText="{
            attention: $t('allerts.Attention'),
            areYouReallySureToDeleteTheItem: $t('allerts.areYouReallySureToDeleteTheItem'),
            close: $t('allerts.close'),
            confirm: $t('allerts.confirm'),
            loading: $t('allerts.loading')
          }"
        />
      </div>
    </div>
  </div>
</template>
<script>
import indexHeader from '@/elements/index/indexHeader.vue'
import indexTable from '@/elements/index/indexTable.vue'

export default {
  data() {
    return {
      path: '/partnersSettlements'
    }
  },

  components: {
    indexHeader,
    indexTable
  }
}
</script>
